// src/constants/errorMessages.ts

const errorMessages = {
    default: "You do not have the required permissions to perform this action. Please contact your administrator.",
    network: "Unable to connect to the server. Please check your internet connection and try again.",
    unauthorized: "You are not signed in or your session has expired or you do not have permission. Please log in again.",
    forbidden: "Access denied. You do not have permission to perform this action. Please contact support.",
    notFound: "The requested resource could not be found. Please check the input or try again later.",
    timeout: "The request took too long to respond. Please refresh and try again.",
    fetchFiles: "We're having trouble retrieving your files. Please refresh the page or contact support if the issue continues.",
    accessDeniedRfq: "Access denied. You do not have the required permissions for this RFQ/ERF. Please reach out to support.",
    nofileSelected: "No files selected. Please choose at least one file to proceed.",
    uploadFileNoFileSelected: "Please select file(s) to upload before continuing.",
    downloadFailed: "One or more files failed to download. Please try again.",
    uploadFailed: "We couldn't upload the file(s). Please try again or contact support.",
    invalidFileFormat: "Unsupported file format. Please upload a valid file.",
    rfqMissing: "RFQ/ERF number is required. Please enter a valid RFQ/ERF and try again.",
    apiLimit: "Too many requests. Please wait a moment before trying again.",
    unauthorizedGroup: "Your account does not belong to the required access group for this RFQ/ERF.",
    sessionExpired: "Your session has expired. Please sign in again to continue.",
    unexpectedError: "An unexpected error occurred. We're looking into it.",
    rfqnotAvailable:"This RFQ/ERF does not exist.",
    loginfailed:"Login failed. Please try again.",
    interactionInProgress:"Sign-in is already in progress. Please wait or reload the page.",
    loginPermission:"Login failed: You do not have sufficient permissions to access this application.",
    authenticationerror: "Authentication is not ready yet. Please refresh the page or try again shortly.",
    containerExpireError: "This RFQ/ERF has expired"
};

export default errorMessages;
